import React, { forwardRef, useContext, useEffect, useRef } from 'react';
import { getLabel } from '../../data/labels';
import { BetslipContext } from './BetslipConf';
import CssCounter from './CssCounter';
import { getConfiguration } from '../utils/configuration';
import { xs_product_code } from '../..';
import { getCurrencyValue } from '../utils/getCurrencyValue';

const Loader = forwardRef(function Loader(props, ref) {
    return (
        <div className="bouncing-cart-loader" {...props} ref={ref}>
            <div></div>
            <div></div>
            <div></div>
        </div> 
    );
});

const Label = forwardRef(function Label(props, ref) {
    return (
        <div className="loader-label" {...props} ref={ref}>
            {props.children}
        </div>
    );
});

function BetslipLoader(props) {
	const betslipContext = useContext(BetslipContext);
	const betslipData = betslipContext.getBetslipData();
	const loaderData = betslipContext.getLoaderData();
    const refCartLoader = useRef();
    const refLoaderLabel = useRef();
    const refCartSuccess = useRef();
	const conf = getConfiguration();
	const showCounterLive = !conf.hcb;


	// const loaderData = {
	// 	type :"success",
	// 	idTicket : 'DF123123123123123',
	// 	successCallback : function() {}
	// };

    // useEffect(() => {
    //     window.toggleFakeBetslipEvent = function() {
    //         betslipContext.setLoaderData({
    //             type :"success",
    //             idTicket : 'DF123123123123123',
    //             successCallback : function() {}
    //         });
    //     }
    // }, []);
	
	const couponKey = betslipData.selectedCoupon;
	const coupon = betslipData.coupons[couponKey];
	const isSinglebets = coupon.selectedContainer === 'singlebets' && !betslipContext.isBetBuilder();

  const vincitaPotenziale = betslipContext.getPotentialWin();
  const freeBetApplied = betslipContext.betOptionsSelection?.type === 'freebet';
  let stakeAmount = 0;
  if (freeBetApplied) {
    stakeAmount = coupon.selectedContainer === 'singlebets' ? coupon.amountSingle
      : coupon.selectedContainer === 'systembets' ? coupon.amountSystem
      : coupon.amountMulti;
  }
  const puntataFreeBet = getCurrencyValue(stakeAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	let eventSingle = null;
	if (isSinglebets) {
		if (loaderData.type === 'prematch' || loaderData.type === 'live') {
			eventSingle = coupon.selections[0];
		}
	}

    const [useCustomPopup, TicketConfirmationPopup] = props.customConfirmationPopup ? [true, props.customConfirmationPopup] : [false, null];

    function closePopup() {
    	if (loaderData.callbackForExitButton) {
    		loaderData.callbackForExitButton();
    	}
		betslipContext.removeBetLoader();
    }

    useEffect(function() {
        try {
            if (xs_product_code == 3) { //desktop
                const boundXSportContainer = document.querySelector("#xsport-container")?.getBoundingClientRect();
                const boundLiveTvContainer = document.querySelector("#live-tv-container")?.getBoundingClientRect();
                const boundStreamingContainer = document.querySelector("#streaming-container")?.getBoundingClientRect();
                const boundCartLoader = refCartLoader?.current?.getBoundingClientRect();
                const boundCartSuccess = refCartSuccess?.current?.getBoundingClientRect();
                const boundLoaderLabel = refLoaderLabel?.current?.getBoundingClientRect();
                const cartLoaderStyle = refCartLoader?.current && getComputedStyle(refCartLoader?.current);
                const cartSuccessStyle = refCartSuccess?.current && getComputedStyle(refCartSuccess?.current);
                const loaderLabelStyle = refLoaderLabel?.current && getComputedStyle(refLoaderLabel?.current);
                const offsetHeight = boundLiveTvContainer?.height || boundStreamingContainer?.height;
    
                if (boundXSportContainer) {
                    if (offsetHeight && refLoaderLabel && boundLoaderLabel && loaderLabelStyle?.position == 'fixed') {
                        refLoaderLabel.current.style.top = `${(boundLoaderLabel.top-boundXSportContainer.top+offsetHeight)}px`;
                    }
                    if (offsetHeight && refCartSuccess && boundCartSuccess && cartSuccessStyle?.position == 'fixed') {
                        refCartSuccess.current.style.top = `${(boundCartSuccess.top-boundXSportContainer.top+offsetHeight)}px`;
                        refCartSuccess.current.style.margin = 'unset';
                    }
                    if (offsetHeight && refCartLoader && boundCartLoader && cartLoaderStyle?.position == 'fixed') {
                        refCartLoader.current.style.top = `${(boundCartLoader.top-boundXSportContainer.top+offsetHeight)}px`;
                    }
                }
            } 
        } catch(err) {
            console.error(err);
        }
    }, [loaderData?.type]);

    function getType1Label(eventSingle) {
        if (eventSingle != null) {
            const bet = eventSingle.bets[0];
            return `${getLabel('carrello.bet_in_progress_part1')} ${eventSingle.descEvent} ${getLabel('carrello.bet_in_progress_part2')} ${bet.descBet} - ${bet.descDraw} ${getLabel('carrello.bet_in_progress_part3')}`;
        }
        
        return getLabel('carrello.bet_in_progress');
    }
    
    function getType2Label(eventSingle) {
        if (eventSingle != null) {
            const bet = eventSingle.bets[0];
            return `${getLabel('carrello.bet_in_n_seconds_part1')} ${eventSingle.descEvent} ${getLabel('carrello.bet_in_n_seconds_part2')} ${bet.descBet} - ${bet.descDraw} ${getLabel('carrello.bet_in_n_seconds_part3')}`;
        }

        return getLabel('carrello.bet_in_n_seconds');
    }
    

    return (
        <>
            {loaderData.type !== 'hideAll' &&
                <div id={`${loaderData.type}-loader`} className="loader-cart">
                    {(loaderData.type === 'prematch' || (loaderData.type === 'live' && !showCounterLive) || loaderData.type === 'live_end_timer') &&
                        <>
                            <Loader ref={refCartLoader} />
                            <Label ref={refLoaderLabel}>
                                {getType1Label(eventSingle)}
                            </Label>
                        </>
                    }
                    {(loaderData.type === 'retry-status-transaction') &&
                        <>
                            <Loader ref={refCartLoader} />
                            <Label ref={refLoaderLabel}>
                                {`[${loaderData.frontendTransactionId}] ${getLabel('general.wait_for_purchase')}`}
                            </Label>
                        </>
                    }
                    {loaderData.type === 'live' && showCounterLive &&
	                    <CssCounter
                            label={getType2Label(eventSingle)}
	                    	seconds={loaderData.remainingSeconds} refCartLoader={refCartLoader} refLoaderLabel={refLoaderLabel}
                        />
                    }
                    {loaderData.type === 'acceptance' &&
                       <>
                            <Loader ref={refCartLoader} />
                            <Label ref={refLoaderLabel}>
                                {getLabel('carrello.approval_pending')}
                            </Label>
                        </>
                    }
                    {loaderData.type === 'success' &&
                        <>
                            {useCustomPopup ?
                                <TicketConfirmationPopup idTicket={loaderData.idTicket} close={closePopup} />
                                :
                                <div className="loader-cart-success">
                                    <div className="animated-checkmark-container">
                                        <svg ref={refCartSuccess} className="animated-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"></circle>
                                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                                        </svg>
                                    </div>

{conf.iwh ?
  <Label ref={refLoaderLabel}>
                                        {getLabel('carrello.ticket_sold')}
                                        <br/>
                                       {/* <span>{getLabel('printer.bordered_ticket.footer.potential_winnings')}: {coupon.potentialWinning}</span> */}
                                        <span className="loader-cart-success-winnings">
                                            {getLabel('mybets.vincitapotenziale', 'Vincita Potenziale')}: <b>{vincitaPotenziale}</b>
                                        </span>
                                        {freeBetApplied &&
                                            <span className="loader-cart-success-freebet">
                                                {getLabel('mybets.inc', 'Inc')} {puntataFreeBet} {getLabel('mybets.freebet', 'Free Bet')}
                                            </span>}
                                        <br/>
                                        {/* {loaderData.idTicket} */}
                                    </Label>
:

                                    <Label ref={refLoaderLabel}>
                                        {getLabel('carrello.ticket_sold')}
                                        <br/>
                                        {loaderData.idTicket}
                                    </Label>
}
                                </div>
                            }
                        </>
                    }
                </div>
            }
        </>
    );
}

export default BetslipLoader;
